import type { AxiosRequestConfig } from "axios";

import { axiosClient } from "@/initializers/axios-client";

// orval requirement - makeRequest MUST be a function. Orval-generated hooks call
// through this so they reuse the shared axios instance (base URL, JWT
// interceptor, 401 handling) and resolve to the response body.
export function makeRequest<T>(
  config: AxiosRequestConfig,
  options?: AxiosRequestConfig,
): Promise<T> {
  return axiosClient({ ...config, ...options }).then(
    (response) => response.data,
  );
}

export default makeRequest;
